/**
 * Billing Entity Enum
 * Must match BillingEntityEnum in backend (src/Enum/BillingEntityEnum.php)
 *
 * Legal entity billing a company, i.e. the ProAbono account its customer,
 * subscriptions and invoices live in. Déclarations Juridiques is the default.
 */
export enum BillingEntity {
  DECLARATIONS_JURIDIQUES = 'declarations-juridiques',
  CAPTURAMA = 'capturama',
}

/**
 * Get all billing entity values
 */
export function getBillingEntityValues(): BillingEntity[] {
  return Object.values(BillingEntity);
}

/**
 * Get label for a billing entity (defaults to Déclarations Juridiques when not set)
 */
export function getBillingEntityLabel(entity: BillingEntity | string | null | undefined): string {
  if (!entity) {
    return 'Déclarations Juridiques';
  }

  switch (entity) {
    case BillingEntity.DECLARATIONS_JURIDIQUES:
      return 'Déclarations Juridiques';
    case BillingEntity.CAPTURAMA:
      return 'Capturama';
    default:
      return entity;
  }
}
